<template>
  <section>
    <div class="row">
      <div class="col-12">
        <h4>Quienes pueden crear estos Trámites</h4>
        <p>Seleccione que usuarios pueden crear trámites de este tipo. Puede seleccionar los que pertenezcan a un Área o Subárea, o los usuarios con determinado Rol.</p>
        <p>Si no selecciona nada, todos los usuarios de todas las áreas van a poder crear este tipo de trámites.</p>
      </div>
      <div class="wrapper-content px-3">
        <div class="row">
          <div class="col-6">
            <div class="row">
              <div class="col-auto d-flex align-items-end">
                <LmTreeSelect
                  :disabled="published"
                  class="mr-4"
                  label="Áreas"
                  clearable
                  pathToGetOptions="/customer/areas"
                  v-model="privilegesData.area"
                  @input="clearSubAreas"
                />
                <LmButton
                  :disabled="!privilegesData.area"
                  buttonClass="btn-primary"
                  @click="onAddPrivilege('area')"
                  :value="$t('add')"
                />
              </div>
              <div class="col-auto d-flex align-items-end">
                <LmTreeSelect
                  class="mr-4"
                  :disabled="!(!!privilegesData.area) || published"
                  label="Subáreas"
                  clearable
                  :pathToGetOptions="subareaOptions"
                  v-model="privilegesData.subarea"
                />
                <LmButton
                  :disabled="!privilegesData.subarea"
                  buttonClass="btn-primary"
                  @click="onAddPrivilege('subarea')"
                  :value="$t('add')"
                />
              </div>
              <div class="col-auto d-flex align-items-end">
                <LmTreeSelect
                  :disabled="published"
                  class="mr-4"
                  label="Roles"
                  clearable
                  pathToGetOptions="/customer/roles"
                  v-model="privilegesData.role"
                />
                <LmButton
                  :disabled="!privilegesData.role"
                  buttonClass="btn-primary"
                  @click="onAddPrivilege('role')"
                  :value="$t('add')"
                />
              </div>
            </div>
          </div>

          <div class="col-6">
              <b-list-group v-if="privileges.length">
                <b-list-group-item v-for="(recipient, index) of privileges" :key="index">
                  <div class="d-flex align-items-center">
                    <i
                      style="font-size: 20px"
                      class="mr-2 mdi"
                      :class="`mdi-${recipient.icon}`"
                    />
                    <span class="flex-grow-1">
                      {{ recipient.name }}
                    </span>
                    <i
                      v-if="!published"
                      style="font-size: 20px"
                      class="mr-2 clickable mdi mdi-close"
                      @click="onDeletePrivilege(recipient)"
                    />
                  </div>
                </b-list-group-item>
              </b-list-group>
              <div v-else>
                <LmSvgIcon
                  icon="LmNoDataIcon"
                  width="7.5em"
                  wrapperClass="mb-4 d-flex justify-content-center"
                />
                <p class="text-center">
                  Todavía no se han seleccionado permisos para los trámites.
                </p>
              </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmButton from '@/components/form/elements/LmButton'
import LmTagsInput from '@/components/form/elements/LmTagsInput'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  mixins: [lmToasts],
  components: {
    LmTreeSelect,
    LmButton,
    LmTagsInput
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    published: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      privilegesData: {
        role: null,
        area: null,
        subarea: null
      }
    }
  },
  computed: {
    privileges () {
      let items = []
      for (const key in this.value) {
        const arr = this.value[key].map(el => {
          return {
            ...el,
            group: key,
            icon: this.setPrivilegeIcon(key)
          }
        })
        items = items.concat(arr)
      }
      return items
    },
    subareaOptions () {
      if (this.privilegesData?.area?.id) {
        return `/codificatorbuilder/codificators/60ef334457c5ac23d879c100/${this.privilegesData?.area?.id}`
      }
      return null
    }
  },
  methods: {
    setPrivilegeIcon (type) {
      const icons = {
        role: 'account-arrow-right-outline',
        area: 'domain',
        subarea: 'account-group'
      }
      return icons[type]
    },
    clearData (prop) {
      this.privilegesData[prop] = null
    },
    onDeletePrivilege (privilege) {
      this.value[privilege.group] = this.value[privilege.group].filter(item => item.id !== privilege.id)
    },
    onAddPrivilege (type) {
      if (this.value[type].some(val => val.id === this.privilegesData[type].id)) {
        this.clearData(type)
        this.lmToastDangerMessage('No se agregaron los privilegios duplicados.', 'Destinatario duplicado')
        return
      }
      this.value[type].push(this.privilegesData[type])
      this.clearData(type)
    },
    clearSubAreas () {
      if (this.privilegesData.subareas) {
        this.privilegesData.subarea = null
      }
    }
  }
}
</script>
